(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8375],{

/***/ 15623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ resetSyncUserProfile; },
  "c": function() { return /* binding */ syncUserProfile; }
});

;// CONCATENATED MODULE: ./utils/CreateThunk.js
var createThunk = function createThunk(_ref) {
  var apiCall = _ref.apiCall,
      type = _ref.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      }, function (payload) {
        return dispatch({
          type: "".concat(type, "_FAILURE"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
var createRejectableThunk = function createRejectableThunk(_ref2) {
  var apiCall = _ref2.apiCall,
      type = _ref2.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
;// CONCATENATED MODULE: ./services/userProfileService.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var syncUserPorfile = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var _profileInfoRequest$r, _profileInfoRequest$r2, _profileInfo$result, _profileInfo$result2, _profileInfoRequest$e;

    var payload, params, profileInfoRequest, profileInfo;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload;

            if (payload.cartId) {
              params = {
                guestCartId: payload.cartId
              };
            }

            _context.next = 4;
            return microServices/* default.post */.Z.post("api", "profileSync", {}, params);

          case 4:
            profileInfoRequest = _context.sent;
            profileInfo = (_profileInfoRequest$r = profileInfoRequest.response) === null || _profileInfoRequest$r === void 0 ? void 0 : (_profileInfoRequest$r2 = _profileInfoRequest$r.data) === null || _profileInfoRequest$r2 === void 0 ? void 0 : _profileInfoRequest$r2.result;

            if (!(!profileInfoRequest.fail && profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.result && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result = profileInfo.result) !== null && _profileInfo$result !== void 0 && _profileInfo$result.magentoProfileResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result2 = profileInfo.result) !== null && _profileInfo$result2 !== void 0 && _profileInfo$result2.magentoProfileResponse[0])) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, profileInfo), {}, {
              pageAction: payload.pageAction
            }));

          case 10:
            if (!(((_profileInfoRequest$e = profileInfoRequest.error) === null || _profileInfoRequest$e === void 0 ? void 0 : _profileInfoRequest$e.status) == 401)) {
              _context.next = 14;
              break;
            }

            throw {
              apiFailStatus: "401"
            };

          case 14:
            throw new Error();

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function syncUserPorfile(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/actions/userProfileAction.js



var syncUserProfile = createThunk({
  apiCall: syncUserPorfile,
  type: actionTypes/* SYNC_USER_PROFILE */.fR
});
var resetSyncUserProfile = function resetSyncUserProfile() {
  return {
    type: actionTypes/* SYNC_USER_PROFILE_RESET */.gC
  };
};

/***/ }),

/***/ 30698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98033);
/* harmony import */ var _carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var CarouselButton = function CarouselButton(_ref) {
  var prev = _ref.prev,
      next = _ref.next,
      className = _ref.className,
      variant = _ref.variant,
      btnSize = _ref.btnSize,
      btnColor = _ref.btnColor,
      btnTheme = _ref.btnTheme,
      handleClick = _ref.handleClick,
      id = _ref.id;

  var handleButtonClick = function handleButtonClick(e) {
    e.preventDefault();

    if (handleClick) {
      handleClick();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "".concat(className, " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["owl--" + variant], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[btnTheme]),
    children: [next && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "owl--next  ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn), " \n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn--" + btnSize], "\n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["btn--next"])),
      onClick: function onClick(event) {
        return handleButtonClick(event);
      },
      id: id,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn__arrow),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
          className: "v-icon-chevron-right ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["".concat(btnColor)], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["icon__".concat(btnSize)])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn__".concat(btnSize)]
      })]
    }), prev && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "owl--prev  ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn), " \n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn--" + btnSize], "\n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["btn--prev"])),
      onClick: function onClick(event) {
        return handleButtonClick(event);
      },
      id: id,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn__arrow),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
          className: "v-icon-chevron-left ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["".concat(btnColor)], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["icon__".concat(btnSize)])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn__".concat(btnSize)]
      })]
    })]
  });
};

CarouselButton.defaultProps = {
  className: "",
  variant: "arc",
  btnSize: "bg",
  btnColor: "white",
  btnTheme: "dark"
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselButton);

/***/ }),

/***/ 32954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ProductCards_ProductCards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14309);
/* harmony import */ var _productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16169);
/* harmony import */ var _productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99599);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28658);
/* harmony import */ var _atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30698);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _services_pageService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76173);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64036);
/* harmony import */ var _dealCard_DealCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8005);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69152);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var ProductCarousel = function ProductCarousel(props) {
  var _;

  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .componentCheckSize */ .Qj)() <= 576;
  var isTablet = 576 < (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .componentCheckSize */ .Qj)() <= 992;
  var isTabletLandscape = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .componentCheckSize */ .Qj)() > 992;
  var tabProducts = props === null || props === void 0 ? void 0 : props.ProductCarouselData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      carouselData = _useState[0],
      setCarouselData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""),
      previousNavClass = _useState2[0],
      setPreviousNavClass = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""),
      nextNavClass = _useState3[0],
      setNextNavClass = _useState3[1];

  var asyncData = [];
  var windowWidth = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .componentCheckSize */ .Qj)();
  var hideButtons = props.hideButtons ? !isMobile && !props.hideButtons : false;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      centerValue = _useState4[0],
      setCenterValue = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    function getCarouselData() {
      return _getCarouselData.apply(this, arguments);
    }

    function _getCarouselData() {
      _getCarouselData = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        var totalProducts, i;
        return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                totalProducts = tabProducts === null || tabProducts === void 0 ? void 0 : tabProducts.length;

                for (i = 0; i < totalProducts; i++) {
                  (0,_services_pageService__WEBPACK_IMPORTED_MODULE_7__/* .productCarouselService */ .HZ)(tabProducts[i].sku).then(function (result) {
                    result = result.products;
                    result = result.items;
                    asyncData.push(result[0]);

                    if (asyncData.length === totalProducts) {
                      setCarouselData(asyncData);
                    }
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getCarouselData.apply(this, arguments);
    }

    if (tabProducts.length < 1) {
      getCarouselData();
    }
  }, []);
  var productCarousel;

  var next = function next() {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  var deviceOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: false,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots-space",
    dotClass: "owl--dot",
    loop: false,
    responsive: {
      0: {
        dots: true,
        autoWidth: false,
        items: 1,
        mouseDrag: true,
        touchDrag: true,
        // center: false,
        slideBy: 1,
        margin: 16
      },
      360: {
        dots: true,
        items: 1,
        autoWidth: true,
        slideBy: 1,
        center: centerValue,
        margin: 16
      },
      375: {
        dots: true,
        items: 1,
        autoWidth: true,
        slideBy: 1,
        center: centerValue,
        margin: 16
      },
      768: (_ = {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 2 : 3
      }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_, "slideBy", 1), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_, "margin", 16), _),
      992: {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 3 : 4,
        margin: 16 // center:false

      },
      1200: {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 3 : 4,
        margin: 16 // center:false

      },
      1280: {
        dots: tabProducts.length > (props.isDeal ? 4 : 5),
        margin: 16,
        // center:false,
        items: props.isDeal ? 4 : 5,
        slideBy: props.isDeal ? 2 : 5
      }
    }
  };
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;

    if ((props === null || props === void 0 ? void 0 : props.carouselId) == "shop-deal-carousel" && index > 0 || (props === null || props === void 0 ? void 0 : props.carouselId) == "shop-product-carousel" && index > 0) {
      setCenterValue(true);
    } else {
      setCenterValue(false);
    }

    var minimum = 0;
    var maximum = event.item.count;
    var idx = index;
    var previousNav = index <= minimum ? "disabled" : "";

    if (isTablet && isTabletLandscape && !isMobile || !props.isDeal && isTablet) {
      idx = index + 2;
    } else if (isTablet && !isTabletLandscape && !isMobile) {
      idx = index + 1;
    } else {
      var _idx = index;
    }

    var nextNav = index + deviceOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  var generateSize = function generateSize() {
    var dealDisplay = 1;
    var productDisplay = 1;

    if (windowWidth > 768 && windowWidth < 1200) {
      dealDisplay = 3;
      productDisplay = 4;
    } else if (windowWidth >= 1200 && windowWidth < 1400) {
      dealDisplay = 3;
      productDisplay = 4;
    } else if (windowWidth >= 1400) {
      dealDisplay = 4;
      productDisplay = 5;
    }

    var displaySize = props.isDeal ? dealDisplay : productDisplay;
    return displaySize;
  };

  var displayData = props.id ? carouselData : tabProducts;

  var handleBuyNow = function handleBuyNow(product, index) {
    var _product$categories, _product$categories$;

    var analyticsViewData = _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_10__/* .getUtagData */ .GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"]);
    var analyticsData = {
      link_type: "o",
      link_name: "".concat(analyticsViewData.page_name, ": product p").concat(index + 1, ": ").concat(product.name).concat(props.tabName ? ": " + props.tabName : ""),
      sales_product_category: [product === null || product === void 0 ? void 0 : (_product$categories = product.categories) === null || _product$categories === void 0 ? void 0 : (_product$categories$ = _product$categories[0]) === null || _product$categories$ === void 0 ? void 0 : _product$categories$.name],
      sales_product_id: [product === null || product === void 0 ? void 0 : product.name],
      sales_product_price: [(0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getFinalPrice */ .eZ)(product)],
      sales_product_quantity: [1]
    };

    if (product !== null && product !== void 0 && product.badges_label) {
      analyticsData.sales_promo_name = [product === null || product === void 0 ? void 0 : product.badges_label];
    }

    if (product !== null && product !== void 0 && product.deal_end_date) {
      analyticsData.deal_expiry = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getDealExpiryTime */ .uJ)(product === null || product === void 0 ? void 0 : product.deal_end_date);
    }

    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_10__/* .link */ .p4(_objectSpread(_objectSpread({}, analyticsViewData), analyticsData));
  };

  var centerAlign = function centerAlign() {
    if (props !== null && props !== void 0 && props.alignment && (props === null || props === void 0 ? void 0 : props.alignment.toLowerCase()) === "center") {
      return "product-carousel-center";
    }

    return "";
  };

  var contentStyle = (props === null || props === void 0 ? void 0 : props.displayStyle) !== "Grid" ? "product-carousel ".concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["custom-container"]), " ").concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default())[props !== null && props !== void 0 && props.alignment ? "custom-styles-".concat(props.alignment) : Number(displayData.length) < Number(generateSize()) && (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["center-styles"])], " ").concat(centerAlign(), " ").concat(tabProducts.length <= (props !== null && props !== void 0 && props.isDeal ? 2 : 3) && "tab-carousel") : "".concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["grid-container"]), " ").concat(isMobile ? (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["grid-container__mobile"]) : "");
  var Wrapper = (props === null || props === void 0 ? void 0 : props.displayStyle) !== "Grid" ? _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_4__.OwlCarousel : function (_ref) {
    var children = _ref.children;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
      children: children
    });
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: (displayData === null || displayData === void 0 ? void 0 : displayData.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: contentStyle,
        children: [Number(displayData === null || displayData === void 0 ? void 0 : displayData.length) > Number(generateSize()) && !hideButtons && (props === null || props === void 0 ? void 0 : props.displayStyle) !== "Grid" && !isMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["custom-container-button"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            prev: true,
            className: "".concat(previousNavClass ? (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default().disabled) : (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["prev-btn"])),
            handleClick: prev,
            variant: !isTablet ? "oval" : "",
            id: props.isDeal ? "ProductCarousel_arrowBackBtn-deal" : "ProductCarousel_arrowBackBtn"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_atoms_buttons_carouselButton_CarouselButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            next: true,
            className: "".concat(nextNavClass ? (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default().disabled) : (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["next-btn"])),
            handleClick: next,
            variant: !isTablet ? "oval" : "",
            id: props.isDeal ? "ProductCarousel_arrowNextBtn-deal" : "ProductCarousel_arrowNextBtn"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(Wrapper, {
          ref: function ref(c) {
            return productCarousel = c;
          },
          options: deviceOptions,
          events: events,
          children: displayData.map(function (item, index) {
            var _item$price_range, _item$price_range$min, _item$price_range$min2, _item$price_range2, _item$price_range2$mi, _item$price_range2$mi2, _item$price_range3, _item$price_range3$ma, _item$price_range3$ma2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: !props.isSearch ? "d-flex ".concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["carousel-container"]), " tab-item ").concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default())[props.isDeal && "margin-style"]) : "".concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["carousel-container"]), " tab-item ").concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default())[props.isDeal && "margin-style"]),
              children: props.isDeal ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_dealCard_DealCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                width: "100%",
                height: "32.938rem",
                img_width: "10rem",
                maxHeight: "33.5rem",
                img_height: "10rem",
                width_mobile: "17.5rem",
                height_mobile: "29.313rem",
                img_width_mobile: "7.5rem",
                img_height_mobile: "7.5rem",
                productName: item === null || item === void 0 ? void 0 : item.name,
                availableIn: props === null || props === void 0 ? void 0 : props.availableIn,
                endsIn: props === null || props === void 0 ? void 0 : props.endsIn,
                imgUrl: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getProductImageUrl */ .G)(item, "image", "No_image"),
                imgUrl_mobile: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getProductImageUrl */ .G)(item, "small_image", "No_image_1"),
                isOutOfStock: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .checkIsOutOfStock */ .zy)(item),
                saveLabel: (item === null || item === void 0 ? void 0 : (_item$price_range = item.price_range) === null || _item$price_range === void 0 ? void 0 : (_item$price_range$min = _item$price_range.minimum_price) === null || _item$price_range$min === void 0 ? void 0 : (_item$price_range$min2 = _item$price_range$min.discount) === null || _item$price_range$min2 === void 0 ? void 0 : _item$price_range$min2.amount_off) != 0 && (item === null || item === void 0 ? void 0 : (_item$price_range2 = item.price_range) === null || _item$price_range2 === void 0 ? void 0 : (_item$price_range2$mi = _item$price_range2.minimum_price) === null || _item$price_range2$mi === void 0 ? void 0 : (_item$price_range2$mi2 = _item$price_range2$mi.discount) === null || _item$price_range2$mi2 === void 0 ? void 0 : _item$price_range2$mi2.amount_off),
                promotionLabel: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionLabel */ .Wp)(item),
                promotionVariant: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionVariant */ .HM)(item),
                promotionLabelColor: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionLabel */ .Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
                planName: item.package_description ? item.package_description : "",
                highlights: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getHighlights */ ._Y)(item),
                originalPrice: item !== null && item !== void 0 && item.monthly_recurring ? item.monthly_recurring : "",
                offerPrice: item !== null && item !== void 0 && item.monthly_recurring ? item.monthly_recurring : "",
                prevPrice: item !== null && item !== void 0 && item.old_monthly_recurring ? item.old_monthly_recurring : "",
                numberOfMonths: item === null || item === void 0 ? void 0 : item.payment_terms_label,
                buttonText: _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_see_details */ .Z.lbl_see_details,
                buttonHandler: props.navigateTo,
                deal_end_date: item === null || item === void 0 ? void 0 : item.deal_end_date,
                deal_go_live_date: item === null || item === void 0 ? void 0 : item.deal_go_live_date,
                deal_label: item === null || item === void 0 ? void 0 : item.deal_label,
                is_deal_locked: item === null || item === void 0 ? void 0 : item.is_deal_locked,
                item: item,
                id: item === null || item === void 0 ? void 0 : item.sku,
                className: props.campaignFlag && "card-style",
                campaignFlag: props.campaignFlag
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ProductCards_ProductCards__WEBPACK_IMPORTED_MODULE_2__["default"], {
                priceRequired: true,
                className: "".concat((_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["custom-styles-carousel"]), " pb-0"),
                finalPriseAlignmiddle: true,
                promotionLabel: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionLabel */ .Wp)(item),
                promotionVariant: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionVariant */ .HM)(item),
                promotionLabelColor: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPromotionLabel */ .Wp)(item) === (item === null || item === void 0 ? void 0 : item.promotion_tag_label) ? item.promotion_tag_swatch : item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
                maximumPrice: item === null || item === void 0 ? void 0 : (_item$price_range3 = item.price_range) === null || _item$price_range3 === void 0 ? void 0 : (_item$price_range3$ma = _item$price_range3.maximum_price) === null || _item$price_range3$ma === void 0 ? void 0 : (_item$price_range3$ma2 = _item$price_range3$ma.regular_price) === null || _item$price_range3$ma2 === void 0 ? void 0 : _item$price_range3$ma2.value,
                minimumPrice: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getAmountOffValue */ .Dd)(item) === "0" ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getFinalPrice */ .eZ)(item) !== "0" ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getFinalPrice */ .eZ)(item) : (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getRegularPrice */ .xZ)(item) : (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getRegularPrice */ .xZ)(item),
                isLowStock: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .checkIsLowStock */ .yB)(item),
                isOutOfStock: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .checkIsOutOfStock */ .zy)(item),
                finalPriceReq: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .checkIsFinalPriceReq */ .z0)(item),
                finalPrice: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getFinalPrice */ .eZ)(item),
                percentOff: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getPercentOffValue */ .FQ)(item),
                amountOff: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getAmountOffValue */ .Dd)(item),
                offerStyle: (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["offer-style"]),
                priceLabelProductStyle: (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["price-label-style"]),
                itemName: item === null || item === void 0 ? void 0 : item.name,
                buyNowReq: true,
                itemImage: item === null || item === void 0 ? void 0 : item.image.url,
                buttonLabelReq: _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_buy_now */ .Z.lbl_buy_now,
                previousPriceReq: true,
                sku: item === null || item === void 0 ? void 0 : item.sku,
                switchReq: props.isSearch,
                isPrepaidOnly: (item === null || item === void 0 ? void 0 : item.bundle_product_price) === null || (item === null || item === void 0 ? void 0 : item.bundle_product_price) === undefined,
                dealProductPrice: item === null || item === void 0 ? void 0 : item.bundle_product_price,
                switchClass: "product-carousel",
                cardWidth: isTabletLandscape ? props.width : props.width_mobile,
                imgWidth: isTabletLandscape ? props.img_width : props.img_width_mobile,
                imgHeight: isTabletLandscape ? props.img_height : props.img_height_mobile,
                priceLabelClassName: (_productCarousel_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["card-price-height"]),
                deal_end_date: item === null || item === void 0 ? void 0 : item.deal_end_date,
                deal_go_live_date: item === null || item === void 0 ? void 0 : item.deal_go_live_date,
                deal_label: item === null || item === void 0 ? void 0 : item.deal_label,
                is_deal_locked: item === null || item === void 0 ? void 0 : item.is_deal_locked,
                item: item,
                id: item === null || item === void 0 ? void 0 : item.sku,
                availableIn: props === null || props === void 0 ? void 0 : props.availableIn,
                endsIn: props === null || props === void 0 ? void 0 : props.endsIn,
                ctaHandler: function ctaHandler() {
                  return handleBuyNow(item, index);
                }
              })
            }, index);
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ProductCarousel);

/***/ }),

/***/ 98033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"owl--oval":"carouselButton_owl--oval__2x4zk","btn":"carouselButton_btn__K9EnQ","btn__bg":"carouselButton_btn__bg__zoNpp","btn--prev":"carouselButton_btn--prev__Z2Xov","btn__sm":"carouselButton_btn__sm__XBSMi","btn__arrow":"carouselButton_btn__arrow__OgC6m","btn--next":"carouselButton_btn--next__HmNG8","btn--sm":"carouselButton_btn--sm__WNEx5","btn--bg":"carouselButton_btn--bg__Y9yXv","owl--po__left":"carouselButton_owl--po__left__m9gqy","owl--po__right":"carouselButton_owl--po__right__HtFGZ","owl--clear":"carouselButton_owl--clear__LELqL","white":"carouselButton_white__4FH5k","black":"carouselButton_black__sMHCV","icon__sm":"carouselButton_icon__sm__P1FDk","icon__bg":"carouselButton_icon__bg__WCM5J","dark":"carouselButton_dark__e1pUx","light":"carouselButton_light__Ezw73"};

/***/ }),

/***/ 16169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-price-height":"productCarousel_card-price-height__dZEVj","custom-styles-carousel":"productCarousel_custom-styles-carousel__m5z5C","deal1":"productCarousel_deal1__nvlpZ","owl-carousel":"productCarousel_owl-carousel__GszKG","owl-stage-outer":"productCarousel_owl-stage-outer__zqHZN","custom-container":"productCarousel_custom-container__njw97","custom-container-button":"productCarousel_custom-container-button__J_b8Y","grid-container":"productCarousel_grid-container__1YzMG","grid-container__mobile":"productCarousel_grid-container__mobile__j86I7","prev-btn":"productCarousel_prev-btn__qeqmZ","next-btn":"productCarousel_next-btn__lIHgq","center-styles":"productCarousel_center-styles__WS5r9","custom-styles-CENTER":"productCarousel_custom-styles-CENTER__A7TKQ","custom-styles-LEFT":"productCarousel_custom-styles-LEFT__6Sq1s","carousel-container":"productCarousel_carousel-container__5n4Ik","align-CENTER":"productCarousel_align-CENTER__zPRdI","align-LEFT":"productCarousel_align-LEFT__UnmrO","disabled":"productCarousel_disabled__Cal7a"};

/***/ })

}]);